import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditorTextBox, PropertyEditorTextBox, PropertyEditorTextBoxPropertyValues } from "./PropertyEditorTextBox";
import { TextBox } from "./TextBox";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorTextBoxMediumPropertyValues =
    PropertyEditorTextBoxPropertyValues
    & {
    };

export type PropertyEditorTextBoxMediumProperties = {
    [name in keyof PropertyEditorTextBoxMediumPropertyValues]: Property<PropertyEditorTextBoxMediumPropertyValues[name]>
};

export interface IPropertyEditorTextBoxMedium extends IPropertyEditorTextBox, PropertyEditorTextBoxMediumProperties
{
}

export class PropertyEditorTextBoxMedium extends PropertyEditorTextBox implements IPropertyEditorTextBoxMedium
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorTextBoxMedium";
    public static override className = "PropertyEditorTextBoxMedium";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorTextBoxMediumPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new TextBox({ maximumLength: 64 }),
            }
        };
    }

    // #endregion

    // #endregion
}

